/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { bool, shape, arrayOf, func, string } from "prop-types";
import { push } from "react-router-redux";
import { withRouter } from "react-router-dom";
import { Hint, Box } from "@ui-kit/components/index.es";

import { actions as fundcorpActions } from "reducers/fundcorp";
import * as i18nUtils from "util/i18n";
import * as configUtils from "util/config";
import { isEnabledMvp, hasPendingFundRequest, isEnabledFundPerformance } from "util/fundcorp";

import Container from "pages/_components/Container";
import I18n from "pages/_components/I18n";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import Image from "pages/_components/Image";
import ContextMenu from "pages/_components/ContextMenu";
import CardContainer from "pages/_components/Card/CardContainer";
import Card from "pages/_components/Card/Card";
import { isMobileNative } from "util/device";

const FORM_ID = "fundcorp.list";

class FundcorpPositionList extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        positions: arrayOf(shape({})).isRequired,
        filtersData: shape({}).isRequired,
        activeEnvironment: bool.isRequired,
        hasPositionsToday: func.isRequired,
        pendingFundRequests: arrayOf(shape({})).isRequired,
        location: shape({ pathname: string, search: string }),
    };

    static defaultProps = {
        location: undefined,
    };

    renderListForPositionByShare = (itemList) => {
        const { isDesktop } = this.props;

        const currency = i18nUtils.get(`fundcorp.list.position.currency.${itemList.positionList[0].monedaSimbolo}`);

        const { title, total } = itemList;
        const match = title.match(/(.*?)\s*(\d+)\s*\|(.*)/);
        const extractedTextBefore = match ? match[1].trim() : "";
        const extractedTextAfter = match ? match[3].trim() : "";
        const extractedNumber = match ? match[2] : "";

        const confFavoriteAccountFundcorp = configUtils.getBoolean(
            "frontend.favoriteAccount.Funds.functionalities",
            false,
        );
        const showFavorite = itemList?.isFavorite && confFavoriteAccountFundcorp;

        return (
            <>
                {isDesktop ? (
                    <>
                        <h2 className="fundcorp__title mt-4 ml-1 mb-1 ellipsis">
                            <div className="d-flex align-items-center">
                                {showFavorite ? (
                                    <Image
                                        src="images/favorito.svg"
                                        className="d-flex w-22px mr-2"
                                        wrapperClassName=""
                                    />
                                ) : null}
                                {extractedTextBefore} {extractedTextAfter}
                                <I18n
                                    id={`${FORM_ID}.position.byFund.column.account`}
                                    componentProps={{ className: "fundcorp__title-account" }}
                                />
                                {extractedNumber}
                            </div>
                        </h2>
                    </>
                ) : (
                    <div className="d-flex align-items-center px-3 mb-0 container">
                        {showFavorite ? (
                            <Image src="images/favorito.svg" className="d-flex w-22px mr-2" wrapperClassName="" />
                        ) : null}
                        <h4 className="fundcorp__title ">
                            {extractedTextBefore} {extractedTextAfter}
                            <span>
                                <I18n
                                    id={`${FORM_ID}.position.byFund.column.account`}
                                    componentProps={{ className: "fundcorp__title-account" }}
                                />
                                {itemList.positionList[0].cuotapartistaNumero}
                            </span>
                        </h4>
                    </div>
                )}
                <Container>
                    {itemList.positionList.map((item) => this.renderListForPositionByShareItem(item, currency))}
                    <Card
                        className={!isDesktop ? "fundcorp__card-total-amount" : null}
                        rightContent={
                            <div className="d-flex fundcorp__card-right-content">
                                <I18n
                                    id={`${FORM_ID}.position.balanceTotal`}
                                    componentProps={{ className: "fundcorp__total-info" }}
                                />
                                <FormattedAmount
                                    currency={currency}
                                    quantity={total}
                                    className="fundcorp__total-data"
                                />
                            </div>
                        }
                    />
                </Container>
            </>
        );
    };

    isFundActive = ({ fondoNumero }) => {
        const fundsParameters = JSON.parse(configUtils.get("frontend.investment.funds.parameters"));
        return fundsParameters[`fondo${fondoNumero}`]?.isON;
    };

    getReturnPath = () => {
        const { location } = this.props;
        if (location?.pathname) {
            return `${location.pathname}${location.search || ""}`;
        }
        return undefined;
    };

    handleSubscribe = (url) => {
        const showMvp4Release = isEnabledMvp("MVP4");
        const { dispatch } = this.props;
        const returnPath = this.getReturnPath();

        if (showMvp4Release) {
            dispatch(fundcorpActions.getInvestorProfile(url, returnPath));
        } else {
            dispatch(push({ pathname: url, state: returnPath ? { return: returnPath } : undefined }));
        }
    };

    handleRescue = (url) => {
        const { dispatch } = this.props;
        const returnPath = this.getReturnPath();
        dispatch(push({ pathname: url, state: returnPath ? { return: returnPath } : undefined }));
    };

    renderContexMenu = (fondo) => {
        const { activeEnvironment, hasPositionsToday } = this.props;
        const showMvp3Release = configUtils.getBoolean("frontend.show.MVP3.functionalities");
        const {
            fondoNumero,
            tipoVCPAbreviatura: fondoAbreviatura,
            monedaIso: fondoMoneda,
            cuotapartistaNumero,
        } = fondo;
        const items = [];

        if (activeEnvironment.permissions.fundSubscribe && this.isFundActive(fondo)) {
            items.push({
                label: "fund.operation.subscribe",
                onClick: () =>
                    this.handleSubscribe(`/fundcorpOperations/subscribe/${fondoNumero}/${cuotapartistaNumero}`),
                icon: "StocksUp",
            });
        }

        if (activeEnvironment.permissions.fundRescue && showMvp3Release && hasPositionsToday()) {
            items.push({
                label: "fund.operation.rescue",
                onClick: () =>
                    this.handleRescue(
                        // eslint-disable-next-line max-len
                        `/fundcorpOperations/rescue/${fondoNumero}/${fondoAbreviatura}/${fondoMoneda}/${cuotapartistaNumero}`,
                    ),
                icon: "RescueDolar",
            });
        }

        if (isEnabledFundPerformance()) {
            const { dispatch } = this.props;
            items.push({
                label: "fundcorp.performance.contextMenu",
                onClick: () => {
                    const params = `opt=performance&c=${cuotapartistaNumero}&f=${fondoNumero}&a=${fondoAbreviatura}`;
                    dispatch(push(`/fundcorpOperations?${params}`));
                },
                icon: "ChartBar",
                iconVariant: "outline",
            });
        }

        if (items.length === 0) {
            return null;
        }

        return <ContextMenu imageStyle="pr-0" items={items} />;
    };

    renderListForPositionByShareItem = (item, currency) => {
        const { isDesktop, pendingFundRequests } = this.props;
        const {
            fondoNombre,
            tipoVCPDescripcion,
            ultimoVCPFecha,
            ultimoVCPValor,
            cuotapartesTotales,
            cuotapartesValuadas,
            fondoNumero,
            cuotapartistaNumero,
        } = item;

        const isBalanceHintEnabled = configUtils.getBoolean("frontend.enable.balance.adjustment.funds", false);
        const balanceHintText = configUtils.get("frontend.balance.adjustment.funds", "");
        const showHint =
            isBalanceHintEnabled && hasPendingFundRequest(fondoNumero, cuotapartistaNumero, pendingFundRequests);

        const separatorVCPDescription = tipoVCPDescripcion.split(" ");
        const clase = separatorVCPDescription[0];
        const vcp = separatorVCPDescription[1];

        if (isDesktop) {
            return (
                <CardContainer className="d-flex flex-column">
                    <Card
                        className="mb-2"
                        content={
                            <div className="d-flex fundcorp__card-content pt-0">
                                <span className="fundcorp__name">{fondoNombre}</span>
                                <div className="fundcorp__card-description">
                                    <span className="fundcorp__card-description-info">{clase}</span>
                                    <span>{vcp}</span>
                                </div>
                                <div className="fundcorp__type">
                                    <I18n
                                        id={`${FORM_ID}.position.byFund.column.shareAmountFound`}
                                        componentProps={{ className: "fundcorp__content-third-info" }}
                                    />
                                    <FormattedAmount
                                        noCurrency
                                        quantity={cuotapartesTotales}
                                        minimumDecimalsCustom={4}
                                        maximumDecimalsCustom={4}
                                        notBold
                                    />
                                </div>
                                {showHint && (
                                    <span className="fundcorp__hint ml-2">
                                        <Hint
                                            iconVariant="outline"
                                            colorIcon="text"
                                            colorText="text"
                                            text={balanceHintText}
                                        />
                                    </span>
                                )}
                            </div>
                        }
                        bottom={
                            <div className="d-flex fundcorp__card-bottom">
                                <div className="d-flex fundcorp__card-last-amount">
                                    <I18n
                                        id={`${FORM_ID}.position.byShare.column.lastValueShare`}
                                        componentProps={{ className: "fundcorp__last-amount-info" }}
                                    />
                                    <FormattedAmount
                                        quantity={ultimoVCPValor}
                                        notBold
                                        currency={currency}
                                        minimumDecimalsCustom={7}
                                        maximumDecimalsCustom={7}
                                    />
                                </div>
                                <div className="d-flex fundcorp__card-date">
                                    <I18n
                                        id={`${FORM_ID}.position.byShare.column.date`}
                                        componentProps={{ className: "fundcorp__date-info" }}
                                    />
                                    <FormattedDate date={ultimoVCPFecha} className="fundcorp__date-data" />
                                </div>
                            </div>
                        }
                        rightContent={
                            <div className="d-flex fundcorp__card-right-content">
                                <div className="fundcorp__card-balance">
                                    <I18n
                                        id={`${FORM_ID}.position.byShare.column.balance`}
                                        componentProps={{ className: "fundcorp__balance-info" }}
                                    />
                                    <FormattedAmount
                                        currency={currency}
                                        className="data-amount"
                                        quantity={cuotapartesValuadas}
                                    />
                                </div>
                                {this.renderContexMenu(item)}
                            </div>
                        }
                    />
                </CardContainer>
            );
        }
        return (
            <CardContainer className="px-3">
                <Card
                    className="fundcorp__card-mobile pb-2"
                    title={
                        <div className="fundcorp__card-title">
                            <span className="fundcorp__name-data">{fondoNombre}</span>
                            <div className={isMobileNative ? "fundcorp__type mobile-native" : "fundcorp__type"}>
                                <span className="fundcorp__class-info">{clase}</span>
                                <span>{vcp}</span>
                            </div>
                            {showHint && (
                                <Box my={4} w="100%">
                                    <Hint
                                        iconVariant="outline"
                                        colorIcon="text"
                                        colorText="text"
                                        my={4}
                                        text={balanceHintText}
                                    />
                                </Box>
                            )}
                            <hr className="mr-0 mb-1" />
                        </div>
                    }
                    content={
                        <div className="fundcorp__card-content pb-0 pt-0">
                            <div className="d-flex fundcorp__card-quantity-amount">
                                <I18n
                                    id={`${FORM_ID}.position.byFund.column.shareAmountFound`}
                                    componentProps={{ className: "fundcorp__quantity-info" }}
                                />
                                <FormattedAmount
                                    className="fundcorp__quantity-data"
                                    quantity={cuotapartesTotales}
                                    noCurrency
                                    minimumDecimalsCustom={4}
                                    maximumDecimalsCustom={4}
                                    notBold
                                />
                            </div>
                            <div className="d-flex fundcorp__card-last-amount">
                                <I18n
                                    id={`${FORM_ID}.position.byShare.column.lastValueShare`}
                                    componentProps={{ className: "fundcorp__last-amount-info" }}
                                />
                                <FormattedAmount
                                    className="fundcorp__last-amount-data"
                                    quantity={ultimoVCPValor}
                                    notBold
                                    currency={currency}
                                    minimumDecimalsCustom={7}
                                    maximumDecimalsCustom={7}
                                />
                            </div>
                            <div className="d-flex fundcorp__card-date">
                                <I18n
                                    id={`${FORM_ID}.position.byShare.column.date`}
                                    componentProps={{ className: "fundcorp__date-info" }}
                                />
                                <FormattedDate date={ultimoVCPFecha} className="fundcorp__date-data" />
                            </div>
                        </div>
                    }
                    rightMenu={<div className="d-flex fundcorp__card-right-content">{this.renderContexMenu(item)}</div>}
                    rightContent={
                        <div className="d-flex fundcorp__card-right-content">
                            <div className="fundcorp__card-balance">
                                <FormattedAmount
                                    currency={currency}
                                    className="data-amount"
                                    quantity={cuotapartesValuadas}
                                />
                            </div>
                        </div>
                    }
                />
            </CardContainer>
        );
    };

    renderListForPositionByFund = (itemList) => {
        const { isDesktop } = this.props;

        const currency = i18nUtils.get(`fundcorp.list.position.currency.${itemList.positionList[0].monedaSimbolo}`);

        const { total, title } = itemList;

        const separatortitle = title.split("Fondo");

        return isDesktop ? (
            <>
                <h2 className="fundcorp__title mt-4 mb-3 ml-1 ellipsis">{separatortitle}</h2>
                {itemList.positionList.map((item) => this.renderListForPositionByFundItem(item, currency))}
                <Card
                    rightContent={
                        <div className="d-flex fundcorp__card-right-content">
                            <I18n
                                id={`${FORM_ID}.position.balanceTotal`}
                                componentProps={{ className: "fundcorp__total-info" }}
                            />
                            <FormattedAmount currency={currency} quantity={total} className="fundcorp__total-data" />
                        </div>
                    }
                />
            </>
        ) : (
            <>
                <h4 className="fundcorp__title mb-0 px-3">{separatortitle}</h4>
                <Container className="flex-grow scrollable">
                    {itemList.positionList.map((item) => this.renderListForPositionByFundItem(item, currency))}
                    <Card
                        className="fundcorp__card-total-amount"
                        rightContent={
                            <div className="d-flex fundcorp__card-right-content">
                                <I18n
                                    id={`${FORM_ID}.position.balanceTotal`}
                                    componentProps={{ className: "fundcorp__total-info" }}
                                />
                                <FormattedAmount
                                    currency={currency}
                                    quantity={total}
                                    className="fundcorp__total-data"
                                />
                            </div>
                        }
                    />
                </Container>
            </>
        );
    };

    renderListForPositionByFundItem = (item, currency) => {
        const { isDesktop, pendingFundRequests } = this.props;
        const confFavoriteAccountFundcorp = configUtils.getBoolean(
            "frontend.favoriteAccount.Funds.functionalities",
            false,
        );
        const showFavorite = item?.isFavorite && confFavoriteAccountFundcorp;
        const {
            cuotapartistaNumero,
            cuotapartistaNombre,
            ultimoVCPFecha,
            ultimoVCPValor,
            cuotapartesTotales,
            cuotapartesValuadas,
            fondoNumero,
        } = item;

        const isBalanceHintEnabled = configUtils.getBoolean("frontend.enable.balance.adjustment.funds", false);
        const balanceHintText = configUtils.get("frontend.balance.adjustment.funds", "");
        const showHint =
            isBalanceHintEnabled && hasPendingFundRequest(fondoNumero, cuotapartistaNumero, pendingFundRequests);

        if (isDesktop) {
            return (
                <CardContainer>
                    <Card
                        content={
                            <div className="d-flex fundcorp__card-content pt-0">
                                <div className="d-flex fundcorp__card-fund-name">
                                    {showFavorite ? (
                                        <Image
                                            src="images/favorito.svg"
                                            className="d-flex w-22px mr-2"
                                            wrapperClassName=""
                                        />
                                    ) : null}
                                    <I18n
                                        id={`${FORM_ID}.position.byShare.title`}
                                        componentProps={{ className: "fundcorp__fund-name-info" }}
                                    />
                                    <span>{cuotapartistaNombre}</span>
                                    <div className="fundcorp__content-second">
                                        <I18n
                                            id={`${FORM_ID}.position.byFund.column.account`}
                                            componentProps={{ className: "fundcorp__content-second-info" }}
                                        />
                                        <span>{cuotapartistaNumero}</span>
                                    </div>
                                    <div className="fundcorp__content-third">
                                        <I18n
                                            id={`${FORM_ID}.position.byFund.column.shareAmountFound`}
                                            componentProps={{ className: "fundcorp__content-third-info" }}
                                        />
                                        <FormattedAmount
                                            className="fundcorp__fund-cuotaparte-data"
                                            noCurrency
                                            quantity={cuotapartesTotales}
                                            notBold
                                            minimumDecimalsCustom={4}
                                            maximumDecimalsCustom={4}
                                        />
                                    </div>
                                    {showHint && (
                                        <span className="fundcorp__hint ml-2">
                                            <Hint
                                                iconVariant="outline"
                                                colorIcon="text"
                                                colorText="text"
                                                text={balanceHintText}
                                            />
                                        </span>
                                    )}
                                </div>
                            </div>
                        }
                        bottom={
                            <div className="d-flex fundcorp__card-bottom">
                                <I18n
                                    id={`${FORM_ID}.position.byFund.column.lastValueShare`}
                                    componentProps={{ className: "fundcorp__fund-cuota-info" }}
                                />
                                <FormattedAmount
                                    className="fundcorp__fund-cuota-data"
                                    quantity={ultimoVCPValor}
                                    notBold
                                    currency={currency}
                                    minimumDecimalsCustom={7}
                                    maximumDecimalsCustom={7}
                                />
                                <I18n
                                    id={`${FORM_ID}.position.byFund.column.date`}
                                    componentProps={{ className: "fundcorp__fund-cuota-date-info" }}
                                />
                                <FormattedDate date={ultimoVCPFecha} />
                            </div>
                        }
                        rightContent={
                            <div className="d-flex fundcorp__card-right-content">
                                <div className="fundcorp__card-balance">
                                    <I18n
                                        id={`${FORM_ID}.position.byFund.column.balance`}
                                        componentProps={{ className: "fundcorp__balance-info" }}
                                    />
                                    <FormattedAmount
                                        currency={currency}
                                        className="data-amount"
                                        quantity={cuotapartesValuadas}
                                    />
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-link p-0 m-0"
                                    onClick={(e) => e.stopPropagation()}>
                                    {this.renderContexMenu(item)}
                                </button>
                            </div>
                        }
                    />
                </CardContainer>
            );
        }
        return (
            <CardContainer className="px-3">
                <Card
                    className="fundcorp__card-mobile"
                    title={
                        <div className="d-flex fundcorp__card-title">
                            <div className="d-flex  align-items-center">
                                {showFavorite ? (
                                    <Image
                                        src="images/favorito.svg"
                                        className="d-flex w-22px mr-2"
                                        wrapperClassName=""
                                    />
                                ) : null}
                                <div>
                                    <I18n
                                        id={`${FORM_ID}.position.byShare.title`}
                                        componentProps={{ className: "fundcorp__name-fund-info" }}
                                    />
                                    <span>{cuotapartistaNombre}</span>
                                </div>
                            </div>
                            <div className={isMobileNative ? "fundcorp__type mobile-native" : "fundcorp__type"}>
                                <I18n
                                    id={`${FORM_ID}.position.byFund.column.account`}
                                    componentProps={{ className: "fundcorp__account-fund-info" }}
                                />
                                {cuotapartistaNumero}
                            </div>
                            <hr className="mr-0 mb-0" />
                        </div>
                    }
                    content={
                        <div className="fundcorp__card-content pt-0">
                            {showHint && (
                                <Box my={4} w="100%">
                                    <Hint
                                        iconVariant="outline"
                                        colorIcon="text"
                                        colorText="text"
                                        my={4}
                                        text={balanceHintText}
                                    />
                                </Box>
                            )}
                            <div className="d-flex fundcorp__card-quantity-amount">
                                <I18n
                                    id={`${FORM_ID}.position.byFund.column.shareAmountFound`}
                                    componentProps={{ className: "fundcorp__quantity-info" }}
                                />
                                <FormattedAmount
                                    className="fundcorp__quantity-data"
                                    quantity={cuotapartesTotales}
                                    noCurrency
                                    minimumDecimalsCustom={4}
                                    maximumDecimalsCustom={4}
                                    notBold
                                />
                            </div>
                            <div className="d-flex fundcorp__card-last-amount">
                                <I18n
                                    id={`${FORM_ID}.position.byShare.column.lastValueShare`}
                                    componentProps={{ className: "fundcorp__last-amount-info" }}
                                />
                                <FormattedAmount
                                    className="fundcorp__last-amount-data"
                                    quantity={ultimoVCPValor}
                                    notBold
                                    currency={currency}
                                    minimumDecimalsCustom={7}
                                    maximumDecimalsCustom={7}
                                />
                            </div>
                            <div className="d-flex fundcorp__card-date">
                                <I18n
                                    id={`${FORM_ID}.position.byFund.column.dateFound`}
                                    componentProps={{ className: "fundcorp__date-info" }}
                                />
                                <FormattedDate date={ultimoVCPFecha} className="fundcorp__date-data" />
                            </div>
                        </div>
                    }
                    rightMenu={
                        <div className="d-flex fundcorp__card-right-content">
                            <button type="button" className="btn btn-link p-0 m-0" onClick={(e) => e.stopPropagation()}>
                                {this.renderContexMenu(item)}
                            </button>
                        </div>
                    }
                    rightContent={
                        <div className="d-flex fundcorp__card-right-content">
                            <div className="fundcorp__card-balance">
                                <FormattedAmount
                                    currency={currency}
                                    className="data-amount"
                                    quantity={cuotapartesValuadas}
                                />
                            </div>
                        </div>
                    }
                />
            </CardContainer>
        );
    };

    render() {
        const { positions, filtersData } = this.props;
        if (!positions || !filtersData) {
            return null;
        }

        if (!(positions && positions.length > 0)) {
            return (
                <div className="text-center no-more-data">
                    <div className="illustration-wrapper">
                        <Image src="images/loupeInFile.svg" className="svg-big-icon" />
                    </div>
                    <p className="text-lead">
                        <I18n id={`${FORM_ID}.empty.message`} />
                    </p>
                </div>
            );
        }

        if (filtersData.positionsType === "byShare") {
            return <>{positions.map((position) => this.renderListForPositionByShare(position))}</>;
        }

        return <>{positions.map((position) => this.renderListForPositionByFund(position))}</>;
    }
}

export default withRouter(FundcorpPositionList);
